import { createStore } from '@ngneat/elf';
import { withEntities } from '@ngneat/elf-entities';
import { ProgressItem } from '@thiememeulenhoff/types';
import { ResultEntry } from './interaction.types';

export const progress = createStore(
  { name: 'progress' },
  withEntities<ProgressItem, 'contentIdentifier'>({
    idKey: 'contentIdentifier',
  }),
);

export const results = createStore(
  { name: 'results' },
  withEntities<ResultEntry, 'contentIdentifier'>({
    idKey: 'contentIdentifier',
  }),
);
